var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[(_vm.emptyHeading)?_c('div',{staticClass:"heading"},[_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.emptyHeading))])]):_vm._e(),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]),_c('img',{staticClass:"empty-image",attrs:{"src":require("../assets/images/Items.svg"),"alt":"Empty icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }